import React, { useCallback } from 'react';
import ParameterVisual from 'components/mix/mix2/ParameterVisual.js';
import { connect } from "react-redux";
import {
    dragEffect,
    setSelectedSendEffect,
} from 'actions/index.js';
import '../../Sends.scss';

function SendEffect(props) {
    const onDragOver = (e) => {
        e.preventDefault();
    };

    const onDragStart = useCallback((e) => {
        props.dragEffect({effectNumber: props.effectNumber});
    }, [props.effectNumber]);

    const onDrop = useCallback((e) => {
        e.stopPropagation()
        if (props.effectDragging === undefined) {
            return;
        }
        let {effectNumber} = props.effectDragging;
        props.moveEffectTo(effectNumber, props.effectNumber);
    }, [props.effectNumber, props.effectDragging]);

    const selectEffect = useCallback((e) => {
        console.log('setting selected send effect=',
            props.isSelected ? undefined : props.effect);
        props.setSelectedSendEffect(
            props.isSelected ? undefined : props.effect);
    }, [props.isSelected, props.effect]);

    let className = "send-effect";
    if (props.isSelected) {
        className += " selected";
    }

    let parameters = props.effect.getParameters();
    if (parameters.length > 10) {
        parameters = parameters.slice(0, 10);
    }
    return (
        <div
          onClick={selectEffect}
          onDragOver={onDragOver}
          onDrop={onDrop}
          onDragStart={onDragStart}
          draggable
          className={className}>
          <div className="effect-name">
            {props.effect.name}
          </div>
          {parameters.map(parameter => <ParameterVisual key={parameter.id} parameter={parameter}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        effectDragging: state.sequencer.effectDragging,
        isSelected: state.effects.selectedSendEffect === props.effect,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        dragEffect: (e) => dispatch(dragEffect(e)),
        setSelectedSendEffect: (e) => dispatch(setSelectedSendEffect(e))
   }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendEffect);
